<template>
  <section class="sme-container__info">
    <template>
      <div
        v-if="isPolicy"
        class="box">
        <table
          class="table table_no_title">
          <div class="th font-14" >Policy Details</div>
          <tr  class="tr ">
            <td class="fw-600">Insured Period</td>
            <td >{{formData.insurance_period}}</td>
          </tr>
          <tr  class="tr ">
            <td class="fw-600">Expected Insured Period</td>
            <td >{{formData.period_date}}</td>
          </tr>
          <tr  class="tr ">
            <td class="fw-600">Total Payable</td>
            <td class="blue">{{formData.amount|formatMoney(2,true)}}</td>
          </tr>
        </table>
      </div>
      <div
        v-for="(item,index) in kycInfo"
        :key="index"
        class="box">
        <table
          class="table"
          :class="item.class" >
          <div class="th font-14" >{{item.title}} <span
            v-if="!isAttachCustomer&&!isFina"
            class="color-del fs-12">{{item.tip}}</span></div>
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr"
            :class="{
              'tr-gray__title':sumItem.isAddress,
              'flex-start': sumItem.showValue2
            }"
          >
            <td class="fw-600">{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'array'"
            >
              <p
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum"
                class="color-dark">{{sum}}</p>
            </td>
            <td
              v-else-if="sumItem.isMoney"
              v-copy="sumItem.value">
              {{sumItem.value|formatMoney(2,true)}}
            </td>
            <td
              v-else-if="sumItem.value"
              v-copy="sumItem.value">
              {{sumItem.value}}
            </td>
            <td v-else-if="sumItem.value1" >
              <template v-if="!sumItem.showValue2">
                <div
                  v-copy="sumItem.value1"
                  :class="sumItem.className">
                  {{sumItem.value1}}
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v2_item, v2_index) in sumItem.value2"
                  :key="v2_index"
                  :class="sumItem.className">
                  <template v-if="Array.isArray(v2_item)">
                    <p
                      v-for="(marketing, marketing_index) in marketingList"
                      :key="marketing_index"
                      v-copy="`${marketing.name}: ${getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}`">
                      {{marketing.name}}: {{getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}}
                    </p>
                  </template>
                  <template v-else>
                    <p v-copy="getOptionName('consentOptions', v2_item)">{{getOptionName('consentOptions', v2_item)}}</p>
                  </template>
                </div>
              </template>
            </td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
          </tr>
        </table>
      </div>
      <table
        v-if="!isCAR"
        class="table mg-b-10">
        <div class="th">Employee's Compensation Details</div>
        <section>
          <tr class="tr">
            <td class="fw-600">Total Number of Employee(s)</td>
            <td>{{ formData.total_employee}}</td>
          </tr>
          <section
            v-for="(occ_item,index) in occ_detail_list"
            :key="'occ_item'+index"
            class="occ_box">
            <tr
              class="tr tr-gray__title">
              <td class="fw-600">Occupation {{index+1}}</td>
            </tr>
            <tr
              class="tr">
              <td class="fw-600">Occupation / Position</td>
              <td v-copy="getOptionName(`SMEJobRoleOption_${smeFormData.class_id}`,occ_item.occ_id)">{{ getOptionName(`SMEJobRoleOption_${smeFormData.class_id}`,occ_item.occ_id)}}</td>
            </tr>
            <section
              v-for="(occ_detail_item,index) in occ_item.occ_detail"
              :key="'occ_detail_item'+index"
              class="occ-detail-tr">
              <template v-if="occ_detail_item.nature_time_enable==1">
                <tr
                  class="tr">
                  <td class="fw-600">{{occ_detail_item.nature_time==1?'Full Time':'Part Time'}}</td>
                  <td v-copy="getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)">{{ getOptionName('smeYesNoOptions', occ_detail_item.nature_time_enable)}}</td>
                </tr>
                <tr class="tr">
                  <td class="fw-600">No. of Employee(s)</td>
                  <td v-copy="occ_detail_item.no_of_employee">{{  occ_detail_item.no_of_employee}}</td>
                </tr>
                <tr class="tr">
                  <td class="fw-600">Estimated Annual Earnings</td>
                  <td v-copy="occ_detail_item.annual_salary">{{  occ_detail_item.annual_salary| formatMoney(2, true)}}</td>
                </tr>
              </template>
            </section>
          </section>
        </section>
      </table>
      <div
        v-for="(item,index) in kycDetailInfo"
        :key="'details_'+index"
        class="box">
        <table
          class="table"
          :class="item.class" >
          <div class="th font-14" >{{item.title}}</div>
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr"
            :class="{
              'tr-gray__title':sumItem.isAddress,
              'flex-start': sumItem.showValue2
            }"
          >
            <td class="fw-600">{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'array'"
            >
              <p
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum"
                class="color-dark">{{sum}}</p>
            </td>
            <td v-else-if="sumItem.isDocument">
              <template v-if="sumItem.isArry">

                <file-container
                  v-for="(doc_item,index) in  sumItem.value"
                  :key="'doc_item'+index"
                  :fileData="doc_item"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  class="mg-b-10"
                  @dock="handleDock"
                />
              </template>
              <template v-else>
                <file-container
                  :fileData="sumItem.value"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  @dock="handleDock"
                />
              </template>
            </td>
            <td v-else-if="sumItem.hasUserId">
              <template v-if="sumItem.customerId">
                <router-link
                  :to="{path:'/accounts/detail',query:{customer_id:sumItem.customerId}}"
                  class="flex flex-wrap text-decoration-none blue">
                  {{sumItem.value}}
                </router-link>
                <div class="tags">
                  <span
                    v-if="referrerDetail.is_tier_base"
                    class="span-status blue">
                    Professional
                  </span>
                  <span
                    v-if="referrerDetail.verify_language"
                    class="span-status"
                    :class="{
                      'verified': referrerDetail.verified == 20,
                      'pending_verify ': referrerDetail.verified == -1,
                      'not_verify': referrerDetail.verified == -2
                    }">
                    {{ referrerDetail.verify_language }}
                  </span>
                  <span
                    v-if="referrerDetail.is_flagged"
                    class="span-status flag">
                    Flagged
                  </span>
                </div>
              </template>
              <span v-else>-</span>
            </td>
            <td
              v-else-if="sumItem.value"
              v-copy="sumItem.value">
              {{sumItem.value}}
            </td>
            <td v-else-if="sumItem.value1" >
              <template v-if="!sumItem.showValue2">
                <div
                  v-copy="sumItem.value1"
                  :class="sumItem.className">
                  {{sumItem.value1}}
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v2_item, v2_index) in sumItem.value2"
                  :key="v2_index"
                  :class="sumItem.className">
                  <template v-if="Array.isArray(v2_item)">
                    <p
                      v-for="(marketing, marketing_index) in marketingList"
                      :key="marketing_index"
                      v-copy="`${marketing.name}: ${getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}`">
                      {{marketing.name}}: {{getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}}
                    </p>
                  </template>
                  <template v-else>
                    <p v-copy="getOptionName('consentOptions', v2_item)">{{getOptionName('consentOptions', v2_item)}}</p>
                  </template>
                </div>
              </template>
            </td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
          </tr>
        </table>
      </div>
      <div
        v-if="isPolicy"
        class="box">
        <table class="table">
          <div class="th">
            <div class="flex flex-aglin-icon">
              <span class="fw-600">Premium</span>
              <font-awesome-icon
                v-if="!isDetail"
                class="icon"
                icon="info-circle"
                @click="handleShowPremium"></font-awesome-icon>
            </div>
          </div>
          <tr
            v-for="(item,index) in sidebarPremium"
            :key="'sude'+index"
            class="tr">
            <td
              class="fw-600"
              v-html="changeLineData(item.item)"></td>
            <td>
              {{ item.premium_str }}
            </td>
          </tr>
        </table>
        <table class="table commssion-table">
          <div class="th">
            <div class="flex flex-aglin-icon">
              <span class="fw-600">Commission Settings</span>
            </div>
          </div>
          <div
            v-for="(item,index) in commission"
            :key="'commission_'+index">
            <template  v-if="!['referrer_net','insurer_net'].includes(item.name)">
              <tr
                :class="{'last-tr':index==(commission.length-1)}"
                class="tr">
                <td
                  class="fw-600"
                  v-html="changeLineData(item.item)"></td>
                <td>
                  <span class="flex">
                    <!--                  <span-->
                    <!--                    v-if="item.name!='gross'"-->
                    <!--                    class="flex-1">{{item.pct}}%</span>-->
                    <span  class="flex-1">
                      {{ item.premium_str }}
                    </span>
                  </span>
                  <!--              {{ item.premium_str }}-->
                </td>
              </tr>
            </template>
            <template v-else>
              <tr  class="tr">
                <td>{{item.name=='referrer_net'?'Referrer Reward(Commission) Rate':'Insurer Commission Rate'}}</td>
                <td>
                  <span class="flex">
                    <span  class="flex-1">
                      {{ item.pct }}%
                    </span>
                  </span>
                  <!--              {{ item.premium_str }}-->
                </td>
              </tr>
              <tr
                v-if="item.name=='insurer_net'"
                class="tr">
                <td>{{item.name=='referrer_net'?'Referrer Net(with levy)':'Insurer Net(with levy)'}}</td>
                <td>{{item.premium_str}}</td>
              </tr>
            </template>
          </div>

        </table>
      </div>
      <div
        v-for="(item,index) in infoLastList"
        :key="'last_'+index"
        class="box">
        <table
          class="table"
          :class="item.class" >
          <div class="th font-14" >{{item.title}}</div>
          <tr
            v-for="(sumItem,sumIndex) in item.list"
            v-show="!sumItem.noShow"
            :key="sumIndex"
            class="tr"
            :class="{
              'tr-gray__title':sumItem.isAddress,
              'flex-start': sumItem.showValue2
            }"
          >
            <td class="fw-600">{{ sumItem.name }}</td>
            <td
              v-if="sumItem.type == 'array'"
            >
              <p
                v-for="(sum,index) in sumItem.value"
                :key="'sum'+index"
                v-copy="sum"
                class="color-dark">{{sum}}</p>
            </td>
            <td v-else-if="sumItem.isDocument">
              <template v-if="sumItem.isArry">

                <file-container
                  v-for="(doc_item,index) in  sumItem.value"
                  :key="'doc_item'+index"
                  :fileData="doc_item"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  class="mg-b-10"
                  @dock="handleDock"
                />
              </template>
              <template v-else>
                <file-container
                  :fileData="sumItem.value"
                  is-show-detail
                  :show-left-name="false"
                  :is-viewer="true"
                  is-none-name
                  @dock="handleDock"
                />
              </template>
            </td>
            <td v-else-if="sumItem.hasUserId">
              <template  v-if="sumItem.customerId">
                <router-link
                  :to="{path:'/accounts/detail',query:{customer_id:sumItem.customerId}}"
                  class="flex flex-wrap text-decoration-none blue">
                  {{sumItem.value}}
                </router-link>

                <div class="tags">
                  <span
                    v-if="referrerDetail.is_tier_base"
                    class="span-status blue">
                    Professional
                  </span>
                  <span
                    v-if="referrerDetail.verify_language"
                    class="span-status"
                    :class="{
                      'verified': referrerDetail.verified == 20,
                      'pending_verify ': referrerDetail.verified == -1,
                      'not_verify': referrerDetail.verified == -2
                    }">
                    {{ referrerDetail.verify_language }}
                  </span>
                  <span
                    v-if="referrerDetail.is_flagged"
                    class="span-status flag">
                    Flagged
                  </span>
                </div>
              </template>
              <span v-else>-</span>
            </td>
            <td
              v-else-if="sumItem.value"
              v-copy="sumItem.value">
              {{sumItem.value}}
            </td>
            <td v-else-if="sumItem.value1" >
              <template v-if="!sumItem.showValue2">
                <div
                  v-copy="sumItem.value1"
                  :class="sumItem.className">
                  {{sumItem.value1}}
                </div>
              </template>
              <template v-else>
                <div
                  v-for="(v2_item, v2_index) in sumItem.value2"
                  :key="v2_index"
                  :class="sumItem.className">
                  <template v-if="Array.isArray(v2_item)">
                    <p
                      v-for="(marketing, marketing_index) in marketingList"
                      :key="marketing_index"
                      v-copy="`${marketing.name}: ${getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}`">
                      {{marketing.name}}: {{getOptionName('consentOptions',v2_item.includes(marketing.id)?1:0)}}
                    </p>
                  </template>
                  <template v-else>
                    <p v-copy="getOptionName('consentOptions', v2_item)">{{getOptionName('consentOptions', v2_item)}}</p>
                  </template>
                </div>
              </template>
            </td>
            <td
              v-else
              v-copy="showCompare(sumItem, formData[sumItem.field])">
              {{ showCompare(sumItem, formData[sumItem.field]) }}
            </td>
          </tr>
        </table>
      </div>
    </template>
    <show-detail-dialog
      v-model="showDetail"
      :type="1"
      is-ticket
      :file="file"></show-detail-dialog>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import ShowDetailDialog from '@/views/records/policy/components/dialog/show-detail'

export default {
  name: 'smeKycInfo',
  components:{
    ShowDetailDialog
  },
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
    showDocument:{
      type:Boolean,
      default:false
    },
    isDetail:{
      type:Boolean,
      default:false
    },
    isQuote:{
      type:Boolean,
      default:false
    },
    isPolicy:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return{
      file:{},
      marketingList: [],
      showDetail:false,
    }
  },
  computed: {
    isFina(){
      let {merchant_platform} = this.formData||{}
      return merchant_platform==2
    },
    isCAR(){
      let {class_id} = this.formData||{}
      return class_id ==79
    },
    sidebarPremium() {
      let {sidebar_info=[]} =this.formData||{}
      return sidebar_info||[]
    },
    commission() {
      let {commission=[]} =this.formData||{}
      return commission||[]
    },
    isAttachCustomer(){
      let {customer={},customer_id}=this.formData||{}
      let {isrd_nm=''} = customer||{}
      return customer_id>0
    },
    occ_detail_list(){
      let {occ_detail_list} = this.smeFormData||{}
      return occ_detail_list||[]
    },
    smeFormData(){
      return this.formData||{}
    },

    upload_document(){
      let {upload_document={}} = this.smeFormData
      return upload_document
    },
    referrerDetail(){
      let{ referrer} = this.smeFormData
      let {detail} =referrer||{}
      return detail||{}
    },
    kycInfo(){
      let {class_id=81,contractor_data={}} = this.formData||{}
      let arr =  [
        {
          title: 'Policyholder Details',
          tip:'(Need attach customer)',
          isBold:true,
          list: [
            {
              name: 'Company Name',
              value: this.smeFormData.isrd_com_nm,
            },
            {
              name: 'CI Number',
              value: this.smeFormData.id_no,
            },
            {
              name: 'Company Phone No.',
              value: this.smeFormData.phone_no,
            },
            {
              name: 'Company Email',
              value: this.smeFormData.email,
            },
            {
              name: 'Contact Person Name',
              field: 'contact_nm',
              value: this.smeFormData.contact_nm,

            },
            {
              name: 'Contact Person Mobile No..',
              field: 'contact_phone',
              value: this.smeFormData.contact_phone,
            },
            {
              name: 'Company Address',
              isAddress:true
            },
            {
              name: 'Room',
              value:this.smeFormData.addr_room,
            },
            {
              name: 'Floor',
              value:this.smeFormData.addr_floor,
            },
            {
              name: 'Block',
              value:this.smeFormData.addr_block,
            },
            {
              name: 'Building / Estate',
              value:this.smeFormData.addr_building,
            },
            {
              name: 'Street',
              value:this.smeFormData.addr_street,
            },
            {
              name: 'District',
              value:this.getAreaName('district', this.smeFormData.addr_district)
            },
            {
              name: 'Area',
              value:this.getAreaName('area', this.smeFormData.addr_area)
            },
            {
              name: 'Country / Region',
              value:this.getAreaName('region', this.smeFormData.addr_region)
            },
          ],
        },
      ]
      let sme_arr =[
        {
          title:'Business Information',
          isSpan:true,
          list:[
            {
              name:'Type',
              value:this.getOptionName(this.isCAR?'newSmeCARProductOption':'newSmeProductOption' ,this.smeFormData.class_id),
            },
            {
              name:'Insured Name',
              value:contractor_data.insured_name,
              noShow:!this.isCAR
            },
            {
              name:'Business Nature',
              value:this.smeFormData.class_id==89?this.smeFormData.bus_nature:this.getOptionName(`SMENatureTime_${class_id}` ,this.smeFormData.bus_nature),
              noShow:this.isCAR
            },
            {
              name:'Is it a newly established company?',
              value:this.getOptionName('smeYesNoOptions',this.smeFormData.newly_com_ind),
              noShow:this.isCAR
            },
            {
              name:'What is sum insured of Contents? (including furniture, fixtures, fittings, machinery & equipment) ',
              value:this.smeFormData.contents_isrd,
              isMoney:true,
              noShow:this.isCAR
            },
            {
              name:'What is the sum insured of stock?',
              value:this.smeFormData.stocks_isrd,
              isMoney:true,
              noShow:this.isCAR
            },
            {
              name:'Sum Insured of Public Liability',
              value:this.smeFormData.total_pl_isrd,
              isMoney:true,
              noShow:this.isCAR
            },
          ]
        },
      ]
      arr = [
        ...arr,
        ...sme_arr
      ]
      let {pcy_cmnt_dt,pcy_expry_dt,main_start_dt,main_end_dt} = contractor_data||{}
      let date = `${this.showHKDate(pcy_cmnt_dt)} - ${this.showHKDate(pcy_expry_dt)}`
      let main_date =  `${this.showHKDate(main_start_dt)} - ${this.showHKDate(main_end_dt)}`
      let quote_arr =  [
        {
          title:'Quote Details',
          isSpan:true,
          list:[
            {
              name:'Expected Effective Date',
              value:this.formData.effective_date,
            },
            {
              name:'Insurer',
              value:this.getSMEOptionName(this.newSMEOptions.insurer,this.formData.company_id),
            },
            {
              name:'Plan Name',
              value:this.formData.plan,
            },
          ]
        },
      ]

      if(this.isQuote){
        arr = [...quote_arr,...arr]
      }
      let work_detail = [
        {
          title: 'Work Details',
          isSpan:true,
          list:[
            {
              name:'Contract Work',
              value:contractor_data.contract_work,
            },
            {
              name: 'Contract Site',
              isAddress:true
            },
            {
              name: 'Room',
              value:contractor_data.cont_addr_room,
            },
            {
              name: 'Floor',
              value:contractor_data.cont_addr_floor,
            },
            {
              name: 'Block',
              value:contractor_data.cont_addr_block,
            },
            {
              name: 'Building / Estate',
              value:contractor_data.cont_addr_building,
            },
            {
              name: 'Street',
              value:contractor_data.cont_addr_street,
            },
            {
              name: 'District',
              value:this.getAreaName('district', contractor_data.cont_addr_district)
            },
            {
              name: 'Area',
              value:this.getAreaName('area', contractor_data.cont_addr_area)
            },
            {
              name: 'Country / Region',
              value:this.getAreaName('region', contractor_data.cont_addr_region)
            },
            {
              name:'Period of Insurance',
              value:date,
            },
            {
              name:'Maintenance Period',
              value:main_date,
            },
            {
              name:'Contract Value',
              value:contractor_data.contract_val,
              isMoney:true
            },
            {
              name:this.isCAR?'Material Damage (Section 1)':'Section I (Material Damage)',
              value:this.getOptionName(this.isCAR?'smeRequiredOptions':'smeYesNoOptions',contractor_data.materials_ind),
            },
            {
              name:this.isCAR?'Third-Party Liability (Section 2)':'Section III (Employee Compensation)',
              value:this.getGlobalOptionName( this.isCAR?'sme_car_contractor_pl':'sme_contractor_pl',contractor_data.pl_isrd),
            },
            {
              name:this.isCAR?'Employee’s Compensation (Section 3)':'Section III (Employee Compensation)',
              value:this.getOptionName(this.isCAR?'smeRequiredOptions':'smeYesNoOptions',contractor_data.employee_ind),
            },
          ]
        },

      ]
      if(this.isCAR)
        arr =[...arr,...work_detail]
      if(this.isPolicy){
        let policy_arr=[
          {
            title:'Policy Details',
            isSpan:true,
            list:[
              {
                name:'Insured Period',
                value:this.formData.insurance_period
              },
              {
                name:'Total Payable',
                value:this.formData.amount
              }
            ]
          }
        ]
      }
      return arr
    },
    kycDetailInfo(){
      let {marketing_data,contractor_data} = this.smeFormData||{}
      let {is_use=0,use_data,other_use} = marketing_data||{}
      let arr =  [
        // {
        //   title: 'Direct Marketing Consent',
        //   isSpan: true,
        //   list: [
        //     {
        //       name: 'Marketing Consent',
        //       value1: this.getOptionName('consentOptions', is_use),
        //       showValue2: is_use === 0,
        //       value2: [is_use, use_data, other_use],
        //       className: 'marketing'
        //     }
        //   ]
        // },
      ]
      if(this.showDocument){
        let document_arr = [
          {
            title:'Upload Document',
            isSpan:true,
            list:[
              {
                name:'Renewal Notice or 3rd Party Quotation',
                value:this.formData.renew_file,
                isDocument:true,
                noShow:this.isCAR
              },
              {
                name:'Business Registration Certificate',
                value:this.formData.br_file,
                isDocument:true
              },
              {
                name:'Contract',
                value:this.formData.contract_file,
                isDocument:true,
                noShow:!this.isCAR
              },
              {
                name:this.isCAR?'Others / Supporting Doc':'Latest 3 months Contribution Record',
                value:this.formData.mpf_files,
                isDocument:true,
                isArry:true
              },
            ]
          }
        ]
        arr = [...document_arr,...arr]
      }
      return arr
    },
    infoLastList(){
      let {referrer={},referrer_user_id,sign_files} = this.formData||{}
      let {isrd_nm,send_mobile,detail} = referrer||{}
      let {id} = detail||{}
      let refer_list = [
        {
          name:'Indicative Code',
          value:this.formData.indicative_code||'-',
        },
        {
          name:'Name',
          value:isrd_nm||'-',
          hasUserId:true,
          customerId:id||''
        },
        {
          name:'Phone Number',
          value:send_mobile||'-',
        },
      ]
      if(!this.isFina){
        refer_list = [
          ...refer_list,
          {
            name:'Referrer Discount',
            value:this.formData.discount_str||'-',
          },
        ]
      }
      let refer_arr =  [
        {
          title:'Referrer',
          isSpan:true,
          list:refer_list
        },
      ]

      let pay_arr = [
        {
          title:'Signature',
          isSpan:true,
          list:[
            {
              name:'Policyholder',
              value:sign_files?sign_files:'-',
              isDocument:sign_files?true:false
            },
          ]
        }
      ]
      let arr = [...refer_arr]
      if(this.isQuote||this.isPolicy){
        arr=[...arr,...pay_arr]
      }
      return arr
    }
  },
  watch:{
    specialOptions:{
      immediate: true,
      deep: true,
      handler(val){
        if(val.marketing_data){
          let arr = JSON.parse(JSON.stringify(val.marketing_data)) || []
          this.marketingList = arr
        }
      }
    },
  },

  methods: {
    handleShowPremium(){
      this.$emit('showPre')
    },
    handleDock(data){
      let {fileData} = data||{}
      let {client_name} = fileData||{}
      this.file  ={...data,title:client_name}
      this.showDetail = true
    },
    showCompare(item, field) {
      var change = field
      return change
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
/deep/.upload-container{
  width: 320px!important;
  .upload-card {
    width: 320px;
    height: 150px;
  }
}
.flex-start{
  align-items: flex-start !important;
}
.marketing + .marketing{
  margin-top: 10px;
}
.tags{
  height: 20px;
  .span-status{
    display: inline-block;
    margin-right: 4px;
    padding: 0px 8px;
    height: 20px;
    border-radius: 100px;
    font-size: 12px;
    line-height: 20px;
    font-weight: 600;
    &.blue{
      color:#0366D6!important;
      border: 1px solid #0366D6;
    }
    &.verified{
      color:#22863a!important;
      border: 1px solid #22863a;
    }
    &.pending_verify{
      color:#dbab09!important;
      border: 1px solid #dbab09;
    }
    &.not_verify{
      color:#d73a49!important;
      border: 1px solid #d73a49;
    }
    &.flag{
      color:#C24E00!important;
      border: 1px solid #F66A0A;
    }
  }
}
.flex-aglin-icon{
  align-items: center;
  h3{
    padding-bottom: 0;
  }
  .icon{
    font-size: 14px;
    line-height: 16px;
    color: #6A737D;
    margin-left: 5px;
    cursor: pointer;
  }
}
/deep/.commssion-table .tr{
border-radius: 0!important;
  &.last-tr{
    border-bottom-left-radius: 6px!important;
    border-bottom-right-radius: 6px!important;
  }
}
</style>
